import {
  GET_SPECIALTIES_RESPONSE,
  GET_SPECIALTY_DETAILS_RESPONSE,
} from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  specialtyDetails: null,
};

const specialties = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SPECIALTIES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case GET_SPECIALTY_DETAILS_RESPONSE:
      return {
        ...state,
        specialtyDetails: action.payload,
      };
    default:
      return state;
  }
};

export default specialties;
